'use client';

import { ShimmeringBlurOverlay } from '@packages/shared/src/ui/ShimmeringBlurOverlay/ShimmeringBlurOverlay';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useLocalizedPageUrl } from '@packages/shared/src/providers/LocalizedPageUrlProvider/useLocalizedPageUrl';
import { usePageTransition } from '@packages/shared/src/providers/PageTransitionProvider/usePageTransition';

export type ProductListBlurOverlayProps = {
  topLevelCategories?: string[];
};

/**
 * Blur overlay component shown during product list page transitions.
 */
export const ProductListBlurOverlay = ({ topLevelCategories }: ProductListBlurOverlayProps) => {
  const {
    i18n: { languages, defaultLocale },
  } = useConfig();

  const nonDefaultLanguages = languages.filter((language) => !defaultLocale.startsWith(language));
  const productListPrefixes = nonDefaultLanguages
    .map((language) => `/${language}/s/`)
    .concat(['/s/'])
    .concat(topLevelCategories?.map((route) => `/${route}`) ?? []);

  const loading = usePageTransition();
  const url = useLocalizedPageUrl();

  const isRelevantTransition =
    loading && productListPrefixes.some((prefix) => url?.startsWith(prefix));

  return <ShimmeringBlurOverlay show={isRelevantTransition} />;
};
